<div class="task__dialog vp-task-watchers-dialog">
  <div class="task__dialog-header">
    <div class="mobile-back-button">
      <button matButton (click)="hide()">
        <mat-icon class="mdi-20px" fontSet="mdi" fontIcon="mdi-close"></mat-icon>
      </button>
    </div>
    <div class="header_lbl disable-select">
      {{ 'ADD_WATCHERS' | translate }}
    </div>
    <div class="desktop-close-button">
      <button matButton (click)="hide()">
        <mat-icon class="disable-select">close</mat-icon>
      </button>
    </div>
  </div>
  <div class="task__dialog-body" [class.save-mode]="isUpdated">
    <div class="watchers-body">
      <mat-form-field class="filter-search-textfield">
        <mat-label>{{ 'SEARCH_WATCHERS' | translate }}</mat-label>
        <input matInput [(ngModel)]="searchText" (ngModelChange)="searchTextChange()">
      </mat-form-field>
      @if (selectedMemberList.length > 0) {
        <div class="selected-list-wrapper">
          <mat-list role="list" class="selectedMemberList">
            @for (member of selectedMemberList; track member) {
              <mat-list-item role="listitem">
                <div class="selected-watcher-list">
                  <span class="member-avatar">
                    <vp-avatar [jid]="member.mail" [avatarId]="member.id" [user]="{ name: member && member.name ? member.name : '', avatarURL: member.avatar }"> </vp-avatar>
                    <span class="selected-member-close-icon" (click)="removeSelectedMember(member)">
                      <mat-icon>close</mat-icon>
                    </span>
                  </span>
                  <div class="selected-member-name">{{ member.name }}</div>
                </div>
              </mat-list-item>
            }
          </mat-list>
        </div>
      }
      <div class="option-list" [class.save-mode]="isUpdated">

        <mat-list role="list">
          @for (member of memberList; track member) {
            <mat-list-item role="listitem" (click)="addMemberToList(member)">
              <vp-avatar [jid]="member.mail" [avatarId]="member.id" [user]="{ name: member && member.name ? member.name : '', avatarURL: member.avatar }"> </vp-avatar>
              <span class="username-place disable-select">{{ (member) ? member.name : ('NO_NAME' | translate) }}</span>
            </mat-list-item>
          }
        </mat-list>
      </div>
    </div>
  </div>
  <div class="task__dialog-footer">
    <div class="desktop-footer">
      <button matButton (click)="hide()">
        {{ 'CANCEL' | translate }}
      </button>
      <button matButton [disabled]="!isUpdated" (click)="addWatchers()">
        {{ 'UPDATE' | translate }}
      </button>
    </div>
    @if (isUpdated) {
      <div class="mobile-footer">
        <div class="title">
          {{ 'ADD_WATCHERS' | translate }}
        </div>
        <div class="save_footer_btn">
          <button matButton (click)="addWatchers()">
            <mat-icon>check</mat-icon>
          </button>
        </div>
      </div>
    }
  </div>
</div>
@if (isLoading) {
  <div class="vnctask-loading">
    <div class="indicator">
      @if (true) {
        <vnc-spinner [size]="'medium'"></vnc-spinner>
      }
    </div>
  </div>
}